import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { AltaDeVendedoresService } from '../../services/alta-de-vendedores.service';
import { TipoDeVendedorService } from '../../services/tipo-de-vendedor.service';
import { IndicadoresVivosService } from 'src/app/aplicaciones-modulos/indicadores-vivos/services/indicadores-vivos.service';
import { CumplimientoVsGananciaService } from '../../services/cumplimiento-vs-ganancia.service';
import { ConfiguracionTiposVariablesIncentivosService } from '../../services/configuracion-tipos-variables-incentivos.service';



@Component({
  selector: 'app-cumplimiento-vs-ganancia',
  templateUrl: './cumplimiento-vs-ganancia.component.html',
  styleUrls: ['./cumplimiento-vs-ganancia.component.css']
})
export class CumplimientoVsGananciaComponent implements OnInit {

  tituloCard: string = 'Cumplimiento vs Ganancia por Tipo de Vendedor y Ganancia';
  tituloForm: string = 'Lista De Cumplimiento vs Ganancia por Tipo de Vendedor y Ganancia';

  formulario: FormGroup;
  formularioEstados: FormGroup;
  formularioFiltroTipoDeVendedores: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  cmbEstadosFiltro: any[] = [
    {
      clave: '1',
      valor: 'ACTIVO'
    },
    {
      clave: '0',
      valor: 'INACTIVO'
    },
  ];

  cmbEstados: any[] = [
    {
      clave: 'ACTIVO',
      valor: 'ACTIVO'
    },
    {
      clave: 'INACTIVO',
      valor: 'INACTIVO'
    },
  ];

  cmbSiNo: any[] = [
    {
      clave: '1',
      valor: 'SI'
    },
    {
      clave: '0',
      valor: 'NO'
    },
  ];

  cmbTipoAsignacion: any[] = [
    {
      clave: 'ASIGNACION_SECUENCIAL',
      valor: 'ASIGNACION_SECUENCIAL'
    },
    {
      clave: 'ASIGNACION_RANGO',
      valor: 'ASIGNACION_RANGO'
    },
  ];

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _serviciosCRUD: CumplimientoVsGananciaService,
    private _tipoDeVendedor: TipoDeVendedorService,
    private _tipoDeVariables: ConfiguracionTiposVariablesIncentivosService,
  ) { }

  ngOnInit() {
    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    this.formulario = this.fb.group({
      idCumpleGana: ['', null],
      tipoVendedorId: ['', []],
      variableId: ['', [Validators.required]],
      cumplimiento: ['', [Validators.required]],
      ganancia: ['', [Validators.required]],
      tipoVendedorDescripcion: ['', []],
      variableDescripcion: ['', []],
      sueldoVariable: ['', []],
      sueldoBaseTipo: ['', []],
      cumplimientoFinal: ['', []],
      tipoAsignacionCumplGanan: ['', [Validators.required]],
    });

    this.formularioFiltroTipoDeVendedores = this.fb.group({
      idTipoVendedor: ['', []],
    });

    this.formularioFiltroTipoDeVendedores.get('idTipoVendedor').valueChanges
      .subscribe((resp) => {
        this.listaVacia = true;
        this.loading = true;

        this._serviciosCRUD.getPorTipoDeVendedor(resp).subscribe((res: any[]) => {
          console.log("getTodo()", res)
          this.loading = false;
          this.listaVacia = (res.length === 0) ? true : false;
          this.rowData = res;
        }, (err) => {
          this.loading = false;
          this.listaVacia = true;
          this.rowData = [];
        });
      });

    this.formulario.get('tipoVendedorId').valueChanges
      .subscribe((resp) => {
        console.log("tipoVendedorId valueChanges", resp);
        console.log("this.listTiposDeVendedores", this.listTiposDeVendedores);
        if (resp != '') {
          
          let index = this.listTiposDeVendedores.findIndex(e => e.idTipo == resp);
          console.log("index", index);
          console.log("index", this.listTiposDeVendedores[index]);
          if (index >= 0) {
            this.formulario.get('sueldoVariable').setValue(this.listTiposDeVendedores[index].sueldoVariable);
          }

          // this._tipoDeVariables.getTodoPorId(resp).subscribe((res: any) => {
          //   console.log("_tipoDeVariables()", res)
          //   this.loading = false;

          //   this.minGanancia = res.minimo;
          //   this.maxGanancia = res.maximo;

          // }, (err) => {
          //   this.loading = false;
          // });

        }
        else {
          this.formulario.get('sueldoVariable').setValue('');
        }
      });

    // this.formulario.get('ganancia').valueChanges
    //   .subscribe((resp) => {
    //     if (resp ) {

    //     }
    //   });

    // this.formulario.get('cumplimiento').valueChanges
    //   .subscribe((resp) => {
    //     if ((resp < this.minGanancia || resp > this.maxGanancia) && (this.maxGanancia > 0)) {
    //       this._utils.mensajeErroToast("% de Cumplimiento no puede ser menor o mayor a la configuración por variable." +
    //         " Mínimo: " + this.minGanancia + " Máximo: " + this.maxGanancia, 5000);
    //     }
    //   });

    this.cargarGridcomponent();
    this.getTodo();
    this.getTiposDeVendedores();
    this.getTiposDeVariables();

  }

  minGanancia = 0;
  maxGanancia = 0;
  minCumplimiento = 0;
  maxCumplimiento = 0;

  listTiposDeVendedores;
  listTiposDeVendedoresFiltro;
  getTiposDeVendedores() {
    this.loading = true;
    this._tipoDeVendedor.getTiposDeVendedoresPorEstado("1").subscribe((res: any[]) => {
      console.log("getTiposDeVendedores()", res)
      this.loading = false;

      this.listTiposDeVendedores = res;
      this.listTiposDeVendedores.unshift({
        descripcion: 'TODOS',
        idTipo: '',
      })

      this.listTiposDeVendedoresFiltro = this.listTiposDeVendedores;

    }, (err) => {
      this.loading = false;
      this.listTiposDeVendedores = [];
    });
  }

  listTiposDeVariables;
  getTiposDeVariables() {
    this.loading = true;
    this._tipoDeVariables.getTodoPorEstado("1").subscribe((res: any[]) => {
      console.log("getTiposDeVariables()", res)
      this.loading = false;
      this.listTiposDeVariables = res;

      for (let i = 0; i < this.listTiposDeVariables.length; i++) {
        this.listTiposDeVariables[i].descripcion = this.listTiposDeVariables[i].idVariable + " - " + this.listTiposDeVariables[i].descripcion;
      }
    }, (err) => {
      this.loading = false;
      this.listTiposDeVariables = [];
    });
  }

  /* FUNCIONES */
  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'idCumpleGana',
        filter: true,
        sortable: true,
        width: 100,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Tipo Vendedor',
        field: 'tipoVendedorDescripcion',
        sortable: true,
        width: 400,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Variable',
        field: 'variableDescripcion',
        sortable: true,
        width: 400,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Cumplimiento',
        field: 'cumplimiento',
        sortable: true,
        width: 150,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Ganancia',
        field: 'ganancia',
        sortable: true,
        width: 150,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();

  }

  nuevo() {
    this.formulario.reset();
    this.formulario.get("tipoVendedorId").setValue("");
    this.formulario.get("tipoAsignacionCumplGanan").setValue("ASIGNACION_SECUENCIAL");
    
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Guardar Configuración';
  }

  currentRow;
  editar({ rowData }) {
    console.log("editar", rowData)
    this.currentRow = rowData;
    rowData.sueldoVariable = rowData.sueldoBaseTipo;
    this.formulario.reset();
    this.formulario.setValue(rowData);
    if (rowData.tipoVendedorId == 0)
      this.formulario.get("tipoVendedorId").setValue("");
    document.getElementById('buttonAbrirModal').click();
  }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
      this.guardar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Cumplimiento vs Ganancia por Tipo de Vendedor y Ganancia';
    this.tituloForm = 'Lista De Cumplimiento vs Ganancia por Tipo de Vendedor y Ganancia';
  }

  /** SERVICIOS */
  getTodo() {

    this.formularioFiltroTipoDeVendedores.get("idTipoVendedor").setValue("");
    // this.listaVacia = true;
    // this.loading = true;

    // this._serviciosCRUD.getTodo().subscribe((res: any[]) => {
    //   console.log("getTodo()", res)
    //   this.loading = false;
    //   this.listaVacia = (res.length === 0) ? true : false;
    //   this.rowData = res;
    // }, (err) => {
    //   this.loading = false;
    //   this.listaVacia = true;
    //   this.rowData = [];
    // });
  }

  eliminar({ rowData }) {
    console.log("eliminar", rowData)
    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this._serviciosCRUD.delete(rowData),
      })
      .then((res: any) => {
        this.getTodo();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

  }

  guardar() {

    let datos = this.formulario.getRawValue();

    if ((this.formulario.get('cumplimiento').value < this.minGanancia || this.formulario.get('cumplimiento').value > this.maxGanancia) && (this.maxGanancia > 0)) {
      this._utils.mensajeErroToast("% de Cumplimiento no puede ser menor o mayor a la configuración por variable." +
        " Mínimo: " + this.minGanancia + " Máximo: " + this.maxGanancia, 5000);

      return;
    }

    datos.tipoVendedorId = datos.tipoVendedorId == '' ? null : datos.tipoVendedorId;

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._serviciosCRUD.save(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getTodo();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  actualizar() {
    console.log("actualizar");
    console.log("cumplimiento", this.formulario.get('cumplimiento').value);
    console.log("minGanancia", this.minGanancia);
    console.log("maxGanancia", this.maxGanancia);
    
    if ((this.formulario.get('cumplimiento').value < this.minGanancia || this.formulario.get('cumplimiento').value > this.maxGanancia) && (this.maxGanancia > 0)) {
      this._utils.mensajeErroToast("% de Cumplimiento no puede ser menor o mayor a la configuración por variable." +
        " Mínimo: " + this.minGanancia + " Máximo: " + this.maxGanancia, 5000);

      return;
    }

    console.log(this.formulario.getRawValue())

    let datos = this.formulario.getRawValue();

    datos.tipoVendedorId = datos.tipoVendedorId == '' ? null : datos.tipoVendedorId;

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._serviciosCRUD.update(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getTodo();
      document.getElementById('cerrarModal').click();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  descargarExcel() {
    let data: any = [];
    let cabecera: any[] = [['ID', 'TIPO VENDEDOR', 'VARIABLE', 'CUMPLIMIENTO', 'GANANCIA']];
    let clonData = this.rowData.map((x) => Object.assign({}, x));
    console.log("clonData", clonData)
    clonData.forEach((e) => {
      data.push(
        {
          idCumpleGana: (e.idCumpleGana === undefined) ? '' : e.idCumpleGana,
          tipoVendedorDescripcion: (e.tipoVendedorDescripcion === undefined) ? '' : e.tipoVendedorDescripcion,
          variableDescripcion: (e.variableDescripcion === undefined) ? '' : e.variableDescripcion,
          cumplimiento: (e.cumplimiento === undefined) ? '' : e.cumplimiento,
          ganancia: (e.ganancia === undefined) ? '' : e.ganancia,
        }
      );
    });
    let name: string = "Cumplimiento_vs_Ganancia.csv";
    this._utils.exportCSV(cabecera, data, name);
    // this._util.mensajeOKToast('El archivo csv se exporto correctame.');
  }

  eliminarTodosLosRegistros(){
    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._serviciosCRUD.deleteTodosVendedores(this.formularioFiltroTipoDeVendedores.get('idTipoVendedor').value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getTodo();
      document.getElementById('cerrarModal').click();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

}
